import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import AllCollectionCard from "components/explore/AllCollectionCard";
import AllCollection from "assets/fake-data/data-collections";
import AllRentedProperties from "assets/fake-data/data-rented-properties";
import OwnProperties from "assets/fake-data/data-own-properties";
import BookedPropertiesData from "assets/fake-data/data-booked-properties";
import { useState } from "react";
// const [visible, setVisible] = useState(9);
// const showMoreItems = () => {
//   setVisible((prevValue) => prevValue + 3);
// };
function Tabbing(props, { visible }) {
  const [activeTab, setActiveTab] = useState(props.activeTab);
  console.log(activeTab);
  return (
    <Tabs
      defaultActiveKey={activeTab}
      id="justify-tab-example"
      className="mb-5"
      justify
    >
      <Tab eventKey={0} onClick={() => setActiveTab(0)} title="Own">
        <div className="row">
          {OwnProperties.slice(0, visible).map((item, index) => (
            <AllCollectionCard key={index} data={item} />
          ))}
        </div>
      </Tab>
      <Tab
        eventKey={1}
        title="Rented (as Owner)"
        onClick={() => setActiveTab(1)}
      >
        <div className="row">
          {AllRentedProperties.slice(0, visible).map((item, index) => (
            <AllCollectionCard key={index} data={item} />
          ))}
        </div>
      </Tab>

      <Tab
        eventKey={2}
        title="Rented (as Tenant)"
        onClick={() => setActiveTab(2)}
      >
        <div className="row">
          {AllRentedProperties.slice(0, visible).map((item, index) => (
            <AllCollectionCard key={index} data={item} />
          ))}
        </div>
      </Tab>
      <Tab eventKey={3} title="Booked" onClick={() => setActiveTab(3)}>
        <div className="row">
          {BookedPropertiesData.slice(0, visible).map((item, index) => (
            <AllCollectionCard key={index} data={item} />
          ))}
        </div>
      </Tab>
    </Tabs>
  );
}

export default Tabbing;
